import React, { useEffect, useState } from 'react';
import '../../styles/status-viewer.css';
import api from '../../utils/api'; 

export default function StatusViewer({ userId, onClose }) {
  const [statuses, setStatuses] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    fetchStatus(userId)
  }, [userId]);

  const fetchStatus = async (userId) => {
    const res = await api.get(`/status/${userId}`);
    setStatuses(res.data);
  }

  const next = () => {
    if (activeIndex < statuses.length - 1) {
      setActiveIndex(prev => prev + 1);
    } else {
      onClose();
    }
  };

  if (statuses.length === 0) return null;

  const status = statuses[activeIndex];

  const getIMGURL = (url) => {
    if (!url) return '/default-avatar.png';
    
    if (url.startsWith('ipfs://')) {
      // Extract the CID (Content ID) from the IPFS URL
      const cid = url.replace('ipfs://', '');
      // Use a public IPFS gateway
      return `https://ipfs.io/ipfs/${cid}`;
    }
    
    return url;
  }

  return (
    <div className="status-viewer-overlay" onClick={next}>
      <div className="status-viewer-content">
        {status.type === 'image' ? (
          <img src={getIMGURL(status.content)} alt="status" className="status-img" />
        ) : (
          <div className="status-text" style={{ backgroundColor: '#1da1f2' }}>
            {status.content}
          </div>
        )}
      </div>
    </div>
  );
}
